
import Footer from '../components/footer.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'


import {
SaunaPreshiftQuery,
SaunaConsumeDetailQuery,
MemberPreshiftQuery
} from '../../static/js/api.js'

function loadtotal(that) {


SaunaPreshiftQuery({StrStartDate:that.value1,StrEndDate:that.value2}, function (res) {

console.log(JSON.parse(res.data.Result))
if (res.data.IsSuccess) {

that.data = JSON.parse(res.data.Result)



var data=JSON.parse(res.data.Result).PayModeDetails


var arr = JSON.parse(res.data.Result).CataConsumes
let tempArr = [], newArrs = []
for (let i = 0; i < arr.length; i++) {
if (tempArr.indexOf(arr[i].GroupName) === -1) {
newArrs.push({
GroupName: arr[i].GroupName,
list: [arr[i]]
})
tempArr.push(arr[i].GroupName);
} else {
for (let j = 0; j < newArrs.length; j++) {
if (newArrs[j].GroupName == arr[i].GroupName) {
newArrs[j].list.push(arr[i])
}
}
}
}



for(var c = 0;c<newArrs.length;c++){
var totalCount = 0;
var totalCon = 0;
var totalpre = 0;
var PaidIn = 0;
for(var d=0;d<newArrs[c].list.length;d++){
var item  = newArrs[c].list[d]
totalCount+=item.Count
totalCon += item.ConsumeMoney;
totalpre += item.PreferentialMoney;
PaidIn += item.PaidIn;
}
newArrs[c].Count = totalCount.toFixed(0)
newArrs[c].ConsumeMoney = totalCon.toFixed(2)
newArrs[c].PreferentialMoney = totalpre.toFixed(2)
newArrs[c].PaidIn = PaidIn.toFixed(2)



}


that.data.CataConsumes=newArrs





var obj={},newArr=[];
var newData=[];
data.forEach(function(item,suffix){

if(!obj[item.GroupName]){
var arr=[];
arr.push(item);
newArr.push(arr);
obj[item.GroupName]=item;
}else{
newArr.forEach(function(value,index){

if(value[0].GroupName==item.GroupName){
value.push(item)
}
})
}



})


for(var i=0;i<newArr.length;i++){
var total={
GroupName: newArr[i][0].GroupName,
PayModeName:"【"+ newArr[i][0].GroupName+"合计"+"】",
OffsetMoney: 0,
PaidIn: 0,
Count: 0,
ShoudPay: 0,
}
for(var k=0;k<newArr[i].length;k++){

total.OffsetMoney+=newArr[i][k].OffsetMoney
total.PaidIn+=newArr[i][k].PaidIn
total.Count+=newArr[i][k].Count
total.ShoudPay+=newArr[i][k].ShoudPay
console.log(1)
console.log(total.OffsetMoney)

}
total.OffsetMoney = total.OffsetMoney.toFixed(2)
total.PaidIn = total.PaidIn.toFixed(2)
total.Count = total.Count.toFixed(0)
total.ShoudPay = total.ShoudPay.toFixed(2)
newArr[i].push(total)




}


var sortArr=[]
for(var j=0;j<newArr.length;j++){

var wordIndex=newArr[j][0].GroupName.substring(0,1)
if(sortArr.length!=0){

var same=false

for(var m=0;m<sortArr.length;m++){
if(sortArr[m].word==wordIndex){
same=true
}


}

if(!same){
sortArr.push({
word:wordIndex,
index:newArr[j]
})
}


}else{
sortArr.push({
word:wordIndex,
index:newArr[j]
})
}



}


var newArrs=sortArr.sort(compare);
function compare(a,b){
return   a.word.charCodeAt(0) - b.word.charCodeAt(0)
}


console.log(newArrs)

var  lastArr=[]
for(var l=0;l<newArrs.length;l++){
lastArr.push(newArrs[l].index)



}




that.data.PayModeDetails=lastArr
MemberPreshiftQuery({StrStartDate:that.value1,StrEndDate:that.value2}, function (ress) {
console.log(ress)
if (ress.data.IsSuccess) {

that.data.huiji = JSON.parse(ress.data.Result)
console.log(that.data.huiji)

let huijiTotal = {
PayModeName: '合计',
ShoudPay: 0,
PaidIn: 0,
OffsetMoney: 0,
Count: 0,
};




var obj={},newArr=[];
var newData=[];
that.data.huiji.PayModeDetails.forEach(function(item,suffix){

if(!obj[item.PayModeName]){
var arr=[];
arr.push(item);
newArr.push(arr);
obj[item.PayModeName]=item;
}else{
newArr.forEach(function(value,index){

if(value[0].PayModeName==item.PayModeName){
value.push(item)
}
})
}



})



console.log(newArr)

var newArrs = []
for(var i=0;i<newArr.length;i++){
var total={
PayModeName: newArr[i][0].PayModeName,
ShoudPay: 0,
PaidIn: 0,
OffsetMoney: 0,
Count: 0,
}
for(var k=0;k<newArr[i].length;k++){

total.OffsetMoney+=newArr[i][k].OffsetMoney
total.PaidIn+=newArr[i][k].PaidIn
total.Count+=newArr[i][k].Count
total.ShoudPay+=newArr[i][k].ShoudPay


}
total.OffsetMoney = total.OffsetMoney.toFixed(2)
total.PaidIn = total.PaidIn.toFixed(2)
total.Count = total.Count.toFixed(0)
total.ShoudPay = total.ShoudPay.toFixed(2)
newArrs.push(total)




}
console.error("111")
console.log(newArrs)
that.huijiCale= newArrs


for(let ht of that.data.huiji.PayModeDetails){
huijiTotal.ShoudPay+= ht.ShoudPay
huijiTotal.PaidIn+= ht.PaidIn
huijiTotal.OffsetMoney+= ht.OffsetMoney
huijiTotal.Count+= ht.Count
console.log(2)

}
huijiTotal.ShoudPay = huijiTotal.ShoudPay.toFixed(2)
huijiTotal.PaidIn = huijiTotal.PaidIn.toFixed(2)
huijiTotal.OffsetMoney = huijiTotal.OffsetMoney.toFixed(2)
huijiTotal.Count = huijiTotal.Count.toFixed(0)

that.huijiTotal = huijiTotal


console.log(' that.huijiTotal')
console.log( that.huijiTotal)












} else {
that.data.huiji = {
IncomeMoney:0,
}
that.huijiTotal = {
PayModeName:'',
ShoudPay:0,
PaidIn:0,
OffsetMoney:0,
Count:0,
}

that.$vux.toast.text(ress.data.ErrorMsg, 'middle')

}


})



} else {

that.$vux.toast.text(res.data.ErrorMsg, 'middle')

}


})


}


function minusDate(s1,s2){

s1 = new Date(s1.replace(/-/g, "/"));
s2 = new Date(s2.replace(/-/g, "/"));
var days = s2.getTime() - s1.getTime();
var time = parseInt(days / (1000 * 60 * 60 * 24));
return time;
}
function getWeekDay(n,type='minus',dateInput=''){
var d = new Date();
if(dateInput){
d = new Date(dateInput.replace(/-/g, "/"));
}
if(type=='minus'){
d.setDate(d.getDate() - n);
}else{
d.setDate(d.getDate() + n);
}

var yy1 = d.getFullYear();
var mm1 = d.getMonth() + 1;
var dd1 = d.getDate();
if (mm1 < 10) {
mm1 = '0' + mm1;
}
if (dd1 < 10) {
dd1 = '0' + dd1;
}
return yy1+'-'+mm1+'-'+dd1
}


function getCurrentYearMonth(baseDate,n=0){
var d= new Date();
console.log('baseDate')
console.log(baseDate)
if(baseDate){
d = new Date(baseDate);
}


if(n){
d.setMonth(d.getMonth() - n);
}
var yy1 = d.getFullYear();
var mm1 = d.getMonth() + 1;
if (mm1 < 10) {
mm1 = '0' + mm1;
}

return yy1+'-'+mm1
}

function getCurrentMonthLast (date){
var endDate = new Date(date); 
var month=endDate.getMonth();
var nextMonth=++month;
var nextMonthFirstDay=new Date(endDate.getFullYear(),nextMonth,1);
var oneDay=1000*60*60*24;
var dateString=new Date(nextMonthFirstDay-oneDay);

return formatDate(dateString); 

};

function formatDate(time,zh=false) {
var date = new Date(time);
var year = date.getFullYear();
/* 在日期格式中，月份是从0开始的，因此要加0
* 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
* */
var month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
var hours = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
var minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
var seconds = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();

if(zh){
return year + "年" + month + "月" + day + "日";

}else{
return year + "-" + month + "-" + day;

}
}

export default {
name: 'app',
components: {
'pc-footer': Footer,
},
directives: {
TransferDom
},
data() {
return {
maxTime:'',
huijiCale:[],
show1:false,
show2:false,
cloneDate:'',
currentTime:'',
value1:'',
value2:'',
showTime:false,
StrStartDate:'',
StrEndDate:'',
currentMonth:'',
showAlert:false,
loading:true,
selectItem:{},
showTable:[],
huijiTotal:{},
selectState:'yesterday',
data: {
ShiftCode: {},
ShiftDate: {},
PayModeDetails: {},
PayModeSummary: {},
GuestPerConsume: {},
CardConsumes: {},
CataConsumes: {},
BarConsumes: {},
IncomeMoney:{},
UnIncomeMoney:{},
CataConsumesSummary:{},
CardSummary:{},
NewMemberDetails:[],
NewMemberSummary: {},
PrepaidDetails: [],
PrepaidSummary:{},
huiji:{
ShiftCode: {},
ShiftDate: {},
PayModeDetails: {}


}

},
selected:1,
selectedsr:1,
msg: 'Welcome to Your Vue.js App',
nav:[
{
id:1,
name:"人数统计"

},
{
id:2,
name:"收入情况"

},
{
id:3,
name:"销售类别"

},{
id:4,
name:"吧台统计"

}

],
navsr:[

{
id:1,
name:"收款统计"

},
{
id:2,
name:"销售明细"

},
{
id:3,
name:"卡种消费"

},{
id:4,
name:"人均消费"

}
,{
id:5,
name:"吧台收入"

},{
id:6,
name:"付款明细"

}


],

showContent001: false,
showContent002: false,
showContent003: false,
showContent004: false,
showContent005: false,
showContent006: false,
showContent007: false,
showContent008: false,
showContent009: false,
}
},

created() {
var that = this


that.value2=getWeekDay(1)
that.value1=getWeekDay(1)




that.currentTime = getWeekDay(1)
that.maxTime = getWeekDay(1)
that.cloneDate = getWeekDay(1)
loadtotal(that)


},
methods:{
onConfirm1(val) {
this.value1 = val

},
onConfirm2(val) {
this.value2 = val
},
changesr(type){
var that = this
that.selectState = type;
if(type=="prev"){
var lastM = getCurrentYearMonth(getWeekDay(0),1)
that.value1= lastM+ '-01'
that.value2 = getCurrentMonthLast (lastM)

}else if(type=="current"){

var currentYM = getCurrentYearMonth()
console.log(currentYM)
that.value1 = currentYM + '-01'
that.value2 = getWeekDay(1)

}else{
that.value1 = getWeekDay(1)
that.value2 = getWeekDay(1)
}
loadtotal(that)

},
showPlugin () {
var that=this
this.$vux.datetime.show({
cancelText: '取消',
confirmText: '确定',
format: 'YYYY-MM-DD',
value: that.currentTime,
endDate: that.maxTime,
onConfirm (val) {
that.currentTime = val
loadAll(that)
},
onShow () {
console.log('plugin show')
},
onHide () {
console.log('plugin hide')
}
})
},



dateFormat:function(time) {
var date=new Date(time);
var year=date.getFullYear();
/* 在日期格式中，月份是从0开始的，因此要加0
* 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
* */
var month= date.getMonth()+1<10 ? "0"+(date.getMonth()+1) : date.getMonth()+1;
var day=date.getDate()<10 ? "0"+date.getDate() : date.getDate();
var hours=date.getHours()<10 ? "0"+date.getHours() : date.getHours();
var minutes=date.getMinutes()<10 ? "0"+date.getMinutes() : date.getMinutes();
var seconds=date.getSeconds()<10 ? "0"+date.getSeconds() : date.getSeconds();

return month+"-"+day+" "+hours+":"+minutes+":"+seconds;
},
toAlert(e){
var that=this
that.selectItem=e;
console.log(e)
that.showAlert=true
that.showTable = e.list


















},
refresh(){
this.loading=true
var that=this
loadtotal(that)


},
change(index){
console.log(index)
this.selected= parseInt(index+1)

},

search(){

var that = this
var data = {
StrStartDate: that.value1,
StrEndDate: that.value2
};
var val =minusDate(that.value1, that.value2)
if(val>31){
alert("对不起，查询跨度最多为31天");
}else{
if(val<0){
alert("结束日期不能小于开始日期");
}else{
this.loading=true
loadtotal(that)
that.selectState=''
that.showTime= false
}

}

}

}

}



// WEBPACK FOOTER //
// ./src/pages/main2.vue